<template>
  <div class="delivery-sms">
    <text-delivery-driver />
    <sms-search />
    <s-m-s-board />
  </div>
</template>

<script lang="ts">
import { onMounted } from 'vue';

import util from '@/Utils/util';

import TextDeliveryDriver from './Delivery/TextDeliveryDriver.vue';
import SmsSearch from './SMSSearch.vue';
import SMSBoard from '@/components/Main/Operator/SMSBoard.vue';

export default {
  name: 'DeliverySMS',

  components: {
    TextDeliveryDriver,
    SmsSearch,
    SMSBoard,
  },

  setup: () => {
    onMounted(util.moveToTop);
  },
};
</script>
